import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useHostName} from 'presentation/hooks';
import {DS_ORIGIN} from '../../constants/dsOrigin';
import {getServicePointsUfs} from '../../services/getServicePointsUfs';

export function useServicePointsUfsQuery() {
	const {
		dataHostNameState: {product},
	} = useHostName();

	return useQuery({
		queryKey: [QUERY_KEYS.SERVICE_POINTS_UFS, product, DS_ORIGIN[product]],
		queryFn: ({signal}) =>
			getServicePointsUfs({
				origem: DS_ORIGIN[product],
				signal,
			}),
		retry: 1,
	});
}
